module.exports = __webpack_public_path__ + "static/img/2.c3ee8ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/2.png
// module id = FmrJ
// module chunks = 0